import { requestTypes } from 'keys'

const useFields = () => {

    const fields = [
        {
            name: "request_type",
            placeholder: "הודעה מסוג",
            component: "autoComplete",
            options: [
                { id: requestTypes.problem, name: "נראה לי שיש בעיה במערכת" },
                { id: requestTypes.question, name: "יש לי שאלה" },
                { id: requestTypes.suggestion, name: "אני רוצה להציע" },
                { id: requestTypes.request, name: "אני רוצה לבקש" },
                { id: requestTypes.other, name: "משהו אחר" },
            ]
        },
        {
            name: "subject",
            component: "input",
            placeholder: "כותרת",
            fullWidth: true
        },
        {
            name: "message",
            component: "input",
            label: "כאן המקום להרחיב",
            placeholder: "כמה שיותר פרטים יותר טוב",
            fullWidth: true,
            rows: 4
        },
        {
            name: "image",
            label: "נוכל להבין יותר טוב אם תצרפו תמונה",
            type: "image",
            component: "uploadFile",
        }
    ]

    return fields
}

export default useFields